import { render } from "./sales-orders.vue?vue&type=template&id=69d27361&scoped=true"
import script from "./sales-orders.vue?vue&type=script&lang=js"
export * from "./sales-orders.vue?vue&type=script&lang=js"

import "./sales-orders.vue?vue&type=style&index=0&id=69d27361&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d27361"]])

export default __exports__